export default "__VITE_ASSET__CvJMzYNj__"